/**
 * La ficha técnica que se escribe en el panel (`ProductoDetalle`) es texto
 * libre, una característica por línea: `Largo: 450 mm`. Random no la manda;
 * la escribe la tienda.
 *
 * Lo que tiene la forma `Campo: valor` va a la tabla de la ficha. Lo que no
 * —una frase suelta, una advertencia— se muestra igual, como nota debajo: se
 * escribió para que alguien lo lea, y descartarlo en silencio sería peor que
 * verlo fuera de la tabla.
 */
import type { Especificacion } from '../componentes/ficha/TablaEspecificaciones';

export interface FichaTecnicaLeida {
  especificaciones: Especificacion[];
  notas: string[];
}

/** Viñetas que alguien pega al principio de la línea: se quitan. */
const VINETA = /^[-–•*·]\s*/;

export function leerFichaTecnica(texto: string | null): FichaTecnicaLeida {
  const leida: FichaTecnicaLeida = { especificaciones: [], notas: [] };
  if (texto === null) return leida;

  for (const cruda of texto.split(/\r?\n/)) {
    const linea = cruda.trim().replace(VINETA, '');
    if (linea.length === 0) continue;

    const dosPuntos = linea.indexOf(':');
    const campo = dosPuntos > 0 ? linea.slice(0, dosPuntos).trim() : '';
    const valor = dosPuntos > 0 ? linea.slice(dosPuntos + 1).trim() : '';

    if (campo.length > 0 && valor.length > 0) leida.especificaciones.push({ campo, valor });
    else leida.notas.push(linea);
  }

  return leida;
}
